import chroma from "chroma-js";

export const hexToRgba = (hex = "", alpha = 1) => {
  return chroma.valid(hex)
    ? chroma(hex)
        .alpha(alpha)
        .css()
    : "inherit";
};
